<template>
  <el-dialog
    append-to-body
    width="500px"
    :title="isAll?'结清':'部分结清'"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="true"
    :close-on-press-escape="false"
  >
    <el-form
      ref="elFormDom"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
      label-width="auto"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="账单日期:" prop="date"
            >{{ form.data.date }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="账单金额:" prop="amount">
            ￥{{ form.data.amount }}</el-form-item
          >
        </el-col>
        <el-col :span="12">
          <el-form-item label="已结金额:" prop="date"
            >￥{{ currentRow.settle_amount }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="未结金额:" prop="amount">
            ￥{{ currentRow.no_settle_amount }}</el-form-item
          >
        </el-col>
        <el-col :span="12">
          <el-form-item label="收款人:" prop="yet_settle_amount"
            >{{ currentRow.bank_account }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户银行:" prop="await_settle_amount"
            >{{ currentRow.bank_name }}</el-form-item
          >
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行卡号:" prop="yet_settle_amount"
            >{{ currentRow.bank_code }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联行号:" prop="await_settle_amount"
            >{{ currentRow.tax_code }}</el-form-item
          >
        </el-col>
        <el-col :span="24">
          <el-form-item label="结算金额:" prop="settleAmount">
            <div class="settle-box">
            <el-input
              v-model="form.data.settleAmount"
              style="width:80%;margin-right:10px"
              clearable
              @input="handleInput"
            ></el-input>
            <div class="titip" v-if="!isAll">剩余{{currentRow.no_settle_amount}}元未结</div>
            <span>元</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件:" prop="image">
            <el-upload
              class="upload-demo"
              action="/api/common/qiniu/uploadFile"
              :limit="10"
              multiple
              :headers="{ token: token }"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              :file-list="form.data.fileList"
              ref="uploadRef"
              accept="image/jpeg, image/png, image/gif, .pdf, .xlsx, .xls , .doc , .docx "
            >
              <el-button :size="subUnitSize" type="primary" plain
                >请上传</el-button
              >
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注:" prop="desc">
            <el-input style="width:80%" v-model="form.data.desc" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button :size="subUnitSize" type="primary" @click="conFirm"
          >确定提交</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import { getStorage } from "@/storage";
export default {
  props: {},
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      token: getStorage("token"),
      visible: false,
      form: {
        data: {
          date: "",
          amount: '',
          settleAmount: "",
          fileList:[],
          image:[],
          desc:'',
        },
        rules: {
            settleAmount: [
              { required: true, message: "请输入", trigger: "blur" },
            ],
            image: [
              // { required: true, message: "请上传", trigger: "blur" },
            ],
          },
      },
      isAll: false,
      currentRow:{},
    };
  },
  methods: {
    toggle(show) {
      this.visible = show;
    },
    getDetail(row, isAll) {
      //账单金额 = 收货金额+运费 - 折扣金额
      this.form.data.amount = (row.total_delivery_money*1000+row.freight_amount*1000 - row.discount_amount*1000)/1000;
      this.form.data.amount = Number(this.form.data.amount).toFixed(2);
      this.form.data.date = row.delivery_date;
      if(isAll){
        this.form.data.settleAmount = row.no_settle_amount;
      }else {
        this.form.data.settleAmount = '';
      }
      this.isAll = isAll;
      this.currentRow = row;
    },
    // 图片上传成功
    handleAvatarSuccess(event,file, fileList) {
      // let fileList_ = this.$refs.uploadRef.uploadFiles;
      // console.log(fileList_,'fileList_')
      //   this.form.data.fileList = fileList_.map((item) => {
      //     return {
      //       url: item.response?.data?.all_path_url || item.url,
      //       name: item.name,
      //     };
      //   });
      //   this.form.data.image = this.form.data.fileList
      //   console.log(this.form.data.image,'this.form.data.image')
    },
    // 移除图片
    handleRemove(file, fileList) {
      // console.log(fileList,'fileList')
      // let fileList_ = this.$refs.uploadRef.uploadFiles;
      // this.form.data.fileList = fileList_.map((item) => {
      //     return {
      //       url: item.response?.data?.all_path_url || item.url,
      //       name: item.name,
      //     };
      // });
      // this.form.data.image = this.form.data.fileList;
      // console.log(this.form.data.image,'this.form.data.image')
    },
    handleInput(value) {
      this.form.data.settleAmount = value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
    },
    reset() {
      this.$refs.elFormDom.resetFields();
      this.form.data.fileList = [];
      this.form.data.image = [];
      this.visible = false;
    },
    conFirm() {
      if(!this.currentRow.bank_account || !this.currentRow.bank_code ||
         !this.currentRow.bank_name || !this.currentRow.tax_code) {
          this.$message({
            type: "error",
            message: '收款人、开户银行、银行卡号、联行号存在未完善不能提交',
          });
          return 
      }
      let fileList_ = this.$refs.uploadRef.uploadFiles;
      this.form.data.image = fileList_.map((item) => {
        return {
          url:item.response?.data?.all_path_url || item.url,
          name:item.name
        }
      });
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let params = {
            supplier_id:this.currentRow.supplier_id,
            date:this.form.data.date,
            amount:this.form.data.settleAmount,
            file:this.form.data.image,
            is_part:this.isAll?2:1,
            desc:this.form.data.desc,
          };
          this.$http.post("/admin/bill/settle", params).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: '付款流程提交成功',
              });
              this.visible = false;
              this.reset();
              this.$emit("settlePartDone");
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
  .settle-box{
    display: flex;
    position: relative;
    .titip{
      position: absolute;
      left:0;
      bottom: -22px;
      font-size: 12px;
      color: #111;
      font-weight: 100;
    }
  }
</style>